export default {
    checklist: {
        answered_by: 'potrdila: {name}',
        title: 'Kontrolni seznam',
        progress: '{answered}/{total} odgovorjeno',
        legend_required: 'Rumen krogec = obvezna točka; brez nje sobe ni mogoče končati.',
        done: 'Opravljeno',
        not_applicable: 'Ni relevantno',
        fault: 'Okvara',
        fault_title: 'Prijavi napako pri tem koraku',
        fault_note: 'Kaj je narobe',
        fault_hint: 'Napiši opaženo — „žarnica pri postelji ne dela" je nalog za vzdrževanje, „okvara" ni.',
        fault_save: 'Samo zapiši napako',
        fault_and_issue: 'Zapiši in ustvari nalog',
        issue_section: 'Nalog za vzdrževanje',
        issue_photo: 'Fotografija (ni obvezna)',
        issue_raised: 'Nalog za vzdrževanje je ustvarjen',
        issue_raised_message: 'Vzdrževanje je obveščeno',
        issue_failed: 'Naloga ni bilo mogoče ustvariti',
        photo_failed: 'Fotografije ni bilo mogoče pripeti',
        incomplete: 'Najprej odgovori na obvezne korake seznama.',
    },
    lost: {
        title: 'Najdeni predmeti',
        hint: 'Kar gost pusti v sobi. Zapiši takoj, s fotografijo — „modri šal" ustreza polovici šalov na svetu, slika pa ne.',
        add: 'Zapiši najdbo',
        search: 'Išči po opisu, številki ali gostu',
        empty: 'Nič zapisanega.',
        description: 'Kaj je',
        description_placeholder: 'Na primer: moder volnen šal',
        room: 'Soba',
        location: 'Kje v sobi',
        location_hint: 'To prepriča gosta po telefonu, da gre res za njegovo stvar.',
        location_placeholder: 'Na primer: v predalu nočne omarice',
        storage: 'Kam shranjeno',
        storage_hint: 'Register, ki ne pove, kje stvar je, ni rešil ničesar.',
        photo: 'Fotografija',
        guest: 'Gost tisto noč: {name}',
        saved: 'Najdba je zapisana.',
        save_failed: 'Najdbe ni bilo mogoče zapisati.',
        photo_failed: 'Zapis je shranjen, fotografije pa ni bilo mogoče naložiti.',
        needs_description: 'Vpiši, kaj je, in izberi sobo.',
        load_failed: 'Seznama ni bilo mogoče naložiti.',
        status_stored: 'V hrambi',
        status_contacted: 'Gost obveščen',
        status_returned: 'Vrnjeno',
        status_shipped: 'Poslano',
        status_disposed: 'Uničeno',
    },
    attention_list: {
        title: 'Zahteva obravnavo',
        hint: 'Naloga in soba se ne ujemata. Pojdi pogledat sobo in jo uredi prek njene naloge.',
        room: 'Soba {room}',
        // V narekovajih, ker sta vstavka od v1.333.0 lahko besedni zvezi („za urediti"),
        // ne le pridevniki — brez njiju se stavek zlije v eno vrstico brez razmejitve.
        mismatch: 'Delo pravi »{expected}«, soba pravi »{actual}«.',
        make_up_room_requested: 'Gost prosi za čiščenje sobe.',
        dnd_at_deadline: 'Znak „ne moti“ je še vedno na vratih, ura, do katere naj bi bila soba gotova, pa je minila.',
        unknown_state: 'neznano',
        settle: 'Urejeno',
        settled: 'Označeno kot pregledano',
        settled_by_hand: 'Ročno pregledano',
        settle_failed: 'Vrstice ni bilo mogoče zapreti',
    },
    round: {
        // Vsak svoj krog na eni uri. Ure pridejo iz API-ja (expected_start/_end) in se
        // tu nikoli ne računajo — hoja živi v storitvi, da se zasloni ne razidejo.
        title:          'Kdaj kdo konča',
        summary:        'zadnja soba ob {time} · {count} krogov',
        finishes:       'konča ob {time}',
        empty:          'Ni odprtega dela na nobenem krogu.',
        legend_working: 'v delu',
        legend_late:    'ne bo pravočasno',
        legend_now:     'zdaj',
        // Rota je načrt, jutro je to, kar je: to ni zavrnitev, ampak dejstvo, ki ga
        // nadzornica išče, ko sprašuje, ali bo hiša pripravljena z ljudmi, ki jih ima.
        after_shift:        'krog gre čez konec izmene',
        legend_after_shift: 'čez konec izmene',
        // Zakaj je blok tam, kjer je: znak na vratih sobo potisne za vse sobe, v katere
        // se da vstopiti. Oznaka in ne barva — barvi na tej vrstici že pomenita „v delu“
        // in „ne bo pravočasno“.
        dnd:                'na vratih „ne moti“',
        // Vrstni red, ki ga nadzornica nastavi z vlečenjem bloka. Zavrnitev ni napaka:
        // soba je bila končana med tem, ko je kartica risala krog, in pot naprej je
        // ponovno branje.
        reorder_saved:  'Vrstni red shranjen',
        reorder_stale:  'Krog se je medtem spremenil. Osvežili smo ga — poskusi znova.',
        reorder_failed: 'Vrstnega reda ni bilo mogoče shraniti.',
    },
    board: {
        // Kaj celica pove o krogu: kdo jo ima in kdaj pride do nje. Ura pride
        // iz API-ja (expected_start) in se tu nikoli ne računa.
        unassigned:  'nedodeljeno',
        norm:        'norma {value}',
        expected_at: 'pride na vrsto ob {time}',
        awaiting_inspection: 'čaka pregled',
        priority: 'naredi prvo',
        // Gostov znak na vratih, v širini ploščice: „Ne moti" in ne kričeči „NE MOTI"
        // iz `live.*`, ki je pisan za trikrat širšo vrstico. Isti besedi nosita tudi
        // legenda in vrstica nad nadstropji, da se pregled ne izraža v treh različicah.
        dnd: 'Ne moti',
        mur: 'Počisti',
        // Pod progami in samo nadzornici: namig nad vsakim blokom bi bil oblaček, ki
        // ga nihče ne prebere, namig sobarici pa navodilo, ki ga ne more izvesti.
        reorder_hint: 'Povleci sobo levo ali desno, da spremeniš vrstni red',
        count_in_progress: 'V urejanju',
        title: 'Pregled sob',
        ground: 'Pritličje',
        floor: '{floor}. nadstropje',
        areas: 'Skupni prostori',
        working: 'nekdo je v sobi',
        in_room: 'V sobi: {name}',
        deferred_overdue: 'preloženo, ura je mimo',
        // Iste besede kot v recepciji (`room_status.*`), le z malo začetnico, ker stojijo
        // v legendi in sredi stavka. Do v1.333.0 sta se portala razhajala tudi po
        // pomenu: `out_of_order` je bil tu „v okvari", `out_of_service` pa „izven
        // uporabe" — kar je v recepciji ime za `out_of_order`. Ista besedna zveza za
        // dve različni oznaki je najdražja vrsta razhajanja, ker je ni videti.
        status_clean: 'počiščena',
        status_dirty: 'za urediti',
        status_inspected: 'pripravljena',
        status_occupied: 'zasedena',
        status_out_of_order: 'izven uporabe',
        status_out_of_service: 'izven prodaje',
    },
    general: {
        hint: 'Namig',
        saved: 'Shranjeno.',
        refreshed_now: 'osveženo zdaj',
        refreshed_ago: 'osveženo pred {value}',
        add:     'Dodaj',
        edit:    'Uredi',
        delete:  'Izbriši',
        cancel:  'Prekliči',
        save:    'Shrani',
        close:   'Zapri',
        confirm: 'Potrdi',
        select_confirm: 'Potrdi',
        selected_count: 'izbranih: {count}',
        yes:     'Da',
        no:      'Ne',
        back:    'Nazaj',
        show_password: 'Pokaži geslo',
        hide_password: 'Skrij geslo',
        no_data: 'Ni podatkov',
        loading: 'Nalaganje …',
        today:   'Danes',
        status:  'Status',
        refresh: 'Osveži',
        search:  'Iskanje',
    },
    // Trajanje se pove tako, kot ga pove hotel: „18 min“ pod uro, „1 h 05“ nad njo.
    // Minute so dvomestne, ker „1 h 5“ bere kot ura in pet ur.
    duration: {
        minutes: '{minutes} min',
        hours:   '{hours} h {minutes}',
    },
    // Vzdrževanje: kaj je pokvarjeno in kdo to popravlja.
    maintenance: {
        title:              'Vzdrževanje',
        room_block_failed:  'Blokada sobe ni uspela — soba je še vedno v prodaji. Sistem samodejno poskuša znova.',
        description:        'Kaj je pokvarjeno in kdo to popravlja.',
        report:             'Prijavi okvaro',
        reported:           'Okvara je prijavljena.',
        fault:              'Okvara',
        area:               'Del objekta',
        area_hint:          'Če ne gre za sobo — dvigalo, kuhinja, parkirišče …',
        room_hint:          'Pusti prazno, če okvara ni v sobi.',
        no_room:            'Brez sobe',
        description_label:  'Opis',
        severity:           'Resnost',
        severity_blocking:  'Blokira sobo',
        severity_normal:    'Navadna',
        severity_cosmetic:  'Kozmetična',
        status_open:        'Prijavljena',
        status_assigned:    'Dodeljena',
        status_in_progress: 'V delu',
        status_resolved:    'Popravljena',
        status_closed:      'Zaključena',
        status_cancelled:   'Preklicana',
        status_duplicate:   'Podvojena',
        start:              'Prevzemi',
        started:            'Okvara je prevzeta.',
        resolve:            'Popravljeno',
        resolved:           'Okvara je označena kot popravljena.',
        resolution:         'Kaj je bilo narejeno',
        resolution_hint:    'Kratek zapis za tistega, ki bo isto okvaro videl čez pol leta.',
        nobody:             'Nihče',
        empty:              'Ni odprtih okvar.',
        filter_mine:        'Moje',
        filter_unassigned:  'Nedodeljene',
        filter_open:        'Vse odprte',
        load_failed:        'Okvar ni bilo mogoče naložiti.',
        action_failed:      'Dejanja ni bilo mogoče izvesti.',
    },
    room: {
        room: 'Soba',
    },
    nav: {
        board: 'Pregled',
        stock: 'Zaloge',
        lost_items: 'Najdeno',
        services:    'Storitve',
        maintenance: 'Vzdrževanje',
        logout:       'Odjava',
        theme:        'Videz',
        theme_light:  'Svetlo',
        theme_dark:   'Temno',
        theme_system: 'Sistemsko',
        language:     'Jezik',
        language_sl:  'Slovenščina',
        language_en:  'Angleščina',
        today:        'Moje naloge',
        sheet:        'Razpored',
        teams:        'Ekipe',
        statistics:   'Statistika',
        my_rota:      'Moj urnik',
        my_time:      'Moja ura',
    },
    rota: {
        title:         'Moj urnik',
        previous_week: 'Prejšnji teden',
        this_week:     'Ta teden',
        next_week:     'Naslednji teden',
        today:         'danes',
        free_day:      'prost dan',
        break_of:      'odmor {minutes}',
        unit_hours:    'h',
        unit_minutes:  'min',

        empty:      'Ta teden nimaš objavljenih turnusov',
        empty_hint: 'Ko vodja objavi teden, se pojavi tukaj.',

        changes_title:    'Spremembe turnusa ({count})',
        pending_title:    'Zahtevki, ki čakajo odločitev: {count}',
        change_moved:     'Turnus {previous} je zdaj {current}.',
        change_withdrawn: 'Turnus {previous} je odpovedan.',
        change_reason:    'Razlog: {reason}',
        change_changed_at: 'Spremenjeno {at}',

        acknowledge:        'Potrjujem',
        acknowledge_hint:   'S potrditvijo poveš, da si spremembo videla. Dokler je ne potrdiš, vodja vidi, da še ne veš.',
        acknowledged:       'Potrjeno.',
        acknowledge_failed: 'Potrditve ni bilo mogoče zapisati.',

        decline:        'Ne morem',
        decline_title:  'Ne moreš delati tega turnusa?',
        decline_hint:   'Vodja bo videla, da ne moreš, in poiskala nadomestilo. Sprememba ostane na seznamu, dokler tega ne uredi.',
        decline_note:   'Razlog (neobvezno)',
        decline_send:   'Pošlji',
        declined:       'Zabeleženo: ne moreš.',
        decline_failed: 'Odgovora ni bilo mogoče zapisati.',

        state_draft:     'Osnutek',
        state_published: 'Objavljen',
        state_cancelled: 'Odpovedan',
    },
    // Evidenca delovnega časa (docs/OSEBJE.md §8): osebna ura in kiosk na hodniku.
    staff_time: {
        today_total:        'Danes',
        of_which_break:     'od tega odmor {minutes}',
        break_counts_hint:  'Odmor šteje v delovni čas in se ne odšteva.',
        first_in:           'prihod {at}',
        last_out:           'odhod {at}',
        day_open:           'Dan ni zaključen — odhod ni zabeležen.',
        this_week:          'Ta teden',
        no_days:            'Ta teden še ni zabeleženih dni.',
        open:               'Nedokončan',
        stamped:            'Zabeleženo: {kind}',
        queued:             'Čaka na povezavo: {count}',
        refused:            'Žig ni bil sprejet.',
        not_recorded:       'Žig ni zabeležen: {reason}',

        kind_clock_in:      'Prihod',
        kind_clock_out:     'Odhod',
        kind_break_start:   'Odmor',
        kind_break_end:     'Konec odmora',

        kiosk_title:        'Ura',
        kiosk_pair_hint:    'Vpiši kodo za registracijo, ki jo pokaže recepcija (Nastavitve → Evidenca delovnega časa). Koda velja pet minut in en poskus.',
        kiosk_code:         'Koda',
        kiosk_pair:         'Registriraj tablico',
        kiosk_code_invalid: 'Ta koda ne velja več. Prosi za novo.',
        kiosk_enter_pin:    'Vpiši svoj PIN',
        kiosk_backspace:    'Zbriši zadnjo številko',
        kiosk_clear:        'Počisti',
        kiosk_today:        'danes {total}',
        kiosk_queued_title: 'Zabeleženo ob {at}',
        kiosk_queued_note:  'Ni povezave — žig se pošlje, ko se vrne. Zapisan je čas pritiska.',
    },

    staff_vacation: {
        // Saldo dopusta na "Zahtevaj dopust" — star (prenesen) in nov (letošnji) dopust,
        // 162. člen ZDR-1. Samo branje; odlok in pravila so v recepcijskem portalu.
        days_count:       '{count} dni',
        available:        'Na voljo',
        old_leave:        'Star dopust ({year})',
        current_leave:    'Letni dopust {year}',
        still_days:       '\u0161e {days}',
        still_of:         '\u0161e {left} od {total}',
        use_by:           'Izrabi do {date}.',
        expired_days:     'Zapadlo {days} \u2014 rok je bil {date}.',
        of_which_pending: 'Od tega \u010daka odlo\u010ditev: {days}',
        not_issued_hint:  'Odlok za to leto \u0161e ni izdan.',
        bucket_old:       'Star',
        bucket_current:   'Nov',
        usage_history:    'Zgodovina uporabe',
        no_usage:         'V tem letu ni zabele\u017eene izrabe dopusta.',
        requested_days:   'Zahtevanih delovnih dni: {days}',
        over_remaining:   'Zahtevek presega razpolo\u017eljivih {days}. Odlo\u010ditev je vseeno na hi\u0161i.',
    },
    staff_absence: {
        // Vrste — NAŠ seznam in začasen (docs/OSEBJE.md §10). Zahtevati je mogoče
        // samo dopust; ostale vrste pridejo v evidenco po drugih poteh.
        kind_vacation:      'Dopust',
        kind_sick_leave:    'Bolniška',
        kind_holiday:       'Praznik',
        kind_training:      'Izobraževanje',
        kind_business_trip: 'Službena pot',
        kind_unexcused:     'Neopravičena odsotnost',
        kind_other:         'Drugo',

        state_requested:    'Zahtevano',
        state_approved:     'Odobreno',
        state_rejected:     'Zavrnjeno',
        state_withdrawn:    'Umaknjeno',

        my_absences:        'Moje odsotnosti',
        no_my_requests:     'Nimaš zahtevkov za odsotnost.',
        request_leave:      'Zahtevaj dopust',
        request_hint:       'Zase lahko zahtevaš dopust. Bolniška se prijavi in evidentira, praznik izhaja iz koledarja, izobraževanje in službeno pot vpiše vodja.',
        request_sent:       'Zahtevek je poslan v odločitev.',
        send_request:       'Pošlji zahtevek',
        decided_by_other:   'O zahtevku odloči nekdo drug — svojega ne moreš potrditi sam.',
        withdraw:           'Umakni',
        withdrawn:          'Zahtevek je umaknjen.',
        from:               'Od',
        to:                 'Do',
        note:               'Opomba',
        range_backwards:    'Konec ne more biti pred začetkom.',
        range_too_long:     'Zahtevek lahko obsega največ {days} dni. Za daljšo odsotnost vpiše dneve vodja.',
    },
    login: {
        demo_signing_in: 'Prijavljam …',
        demo_failed: 'Te vloge na tem strežniku ni.',
        title:    'Prijava',
        subtitle: 'Portal za gospodinjstvo in nadzor',
        username: 'Uporabniško ime',
        password: 'Geslo',
        submit:   'Prijava',
        failed:   'Napačno uporabniško ime ali geslo',
    },
    property: {
        property:   'Objekt',
        properties: 'Objekti',

        unavailable_title:       'Objekt ni znan',
        unavailable_description: 'Ta račun ne more prebrati seznama objektov (manjka pravica property:read), zato portal ne ve, za katero hišo gre. Obrni se na administratorja.',

        rooms_restricted_title:       'Številke sob niso na voljo',
        rooms_restricted_description: 'Nekatere naloge nimajo številke sobe. Delo je prikazano, sobo pa je treba poiskati po seznamu.',
    },
    today: {
        awaiting_inspection: 'Za pregled',
        awaiting_description: 'Sobe so končane in čakajo, da jih nekdo sprejme. Najdlje čakajoča je prva.',
        awaiting_me:         'Čaka na tvoj pregled',
        waiting_for:         'čaka {value}',
        // „Moje naloge“ in ne „Danes“: zaslon ni dan, ampak to, kar ima ta oseba
        // pred sabo — svoje sobe, proste sobe in (za nadzornico) sobe za pregled.
        // Poslovni datum ostane v podnaslovu, kjer je bil vedno.
        title:    'Moje naloge',
        subtitle: 'Sobe za današnji poslovni dan',

        progress: 'Opravljeno',

        my_rooms:               'Moje sobe',
        // Zakaj seznam ni po nadstropjih: vrstni red je krog, kakršnega je razporedila
        // nadzornica (docs/HOUSEKEEPING.md §5.1.4), in soba iz tretjega nadstropja je
        // lahko pred sobo iz prvega. Brez tega stavka je to videti kot napaka.
        my_rooms_description:   'Po vrsti, kot naj hodiš — nadstropje piše ob številki sobe.',
        unassigned_rooms:       'Nedodeljene sobe',
        unassigned_description: 'Te sobe še niso dodeljene nikomur. Če katero vzameš, pritisni Prevzemi.',

        floor_unknown: 'Neznano nadstropje',

        empty: 'Za danes zate ni nobene sobe.',
    },
    sheet: {
        title:    'Razpored',
        subtitle: 'Vse sobe današnjega poslovnega dne',

        generate:         'Ustvari razpored',
        generate_confirm: 'Ustvari naloge za današnji poslovni dan. Naloge, ki že obstajajo, ostanejo nedotaknjene.',
        generate_failed:  'Razporeda ni bilo mogoče ustvariti.',
        generated_message: 'Ustvarjenih nalog: {count}',

        filter_status: 'Status',
        filter_kind:   'Vrsta dela',
        all_statuses:  'Vsi statusi',
        all_kinds:     'Vse vrste dela',
        floor_rooms:    '{count} soba | {count} sobi | {count} sobe | {count} sob',
        floor_areas:    '{count} prostor | {count} prostora | {count} prostori | {count} prostorov',
        floor_open:     '{count} za delo',
        // Dodeljenost je druga os kot status: soba, ki čaka, je lahko dodeljena, soba
        // v delu pa vedno je. Šteje se ista množica kot pri „za delo“.
        floor_unassigned:   '{count} nedodeljenih',
        floor_all_assigned: 'vse dodeljene',
        person_summary: 'še za delo: {open} od {total}',
        // Škatla, ki ni status in ni filter — koliko odprtega dela ima svojo osebo.
        assigned_count: 'Dodeljeno',
        group_by_floor:  'Po nadstropjih',
        // Ostane 'Po osebah' v kodi kot identifikator; napis je „Po izvajalcih“, ker je
        // izvajalec oseba ALI ekipa (docs/HOUSEKEEPING.md §15).
        group_by_person:   'Po osebah',
        group_by_executor: 'Po izvajalcih',
        round_ends: 'konča ob {time}',

        empty: 'Za ta dan ni nalog. Če nočni zaključek še ni tekel, pritisni Ustvari razpored.',

        assign_restricted_title:       'Dodeljevanje ni na voljo',
        assign_restricted_description: 'Ta račun ne more prebrati seznama osebja gospodinjstva tega objekta (manjka pravica housekeeping:inspect), zato sob ni mogoče dodeliti.',
    },
    timeline: {
        search: 'Soba ali oseba',
        no_match: 'Za to iskanje ni zapisov.',
        title:       'Pregled dneva',
        description: 'Kdaj je soba prišla v delo, kdo jo je prevzel in uredil, kdo pregledal.',
        empty:       'Danes se še ni nič zgodilo.',
        started:     'prevzeta v čiščenje',
        finished:    'počiščena',
        skipped:     'preskočena',
        inspected:   'sprejeta',
        days_today: 'Danes',
        days_3: 'Zadnji 3 dnevi',
        days_7: 'Zadnjih 7 dni',
        days_14: 'Zadnjih 14 dni',
    },
    attention: {
        title: 'Posebnosti sobe',
        add: 'Dodaj posebnost',
        add_one: 'Dodaj na seznam',
        on_this_day: 'Vpisano za danes',
        what: 'Kaj',
        value: 'Podatek',
        value_hour: 'Ura',
        note: 'Opomba',
        from_reservation: 'iz rezervacije',
        from_guest: 'iz kartice gosta',
        from_task: 'vpisano danes',
        vip: 'VIP',
        cot: 'Otroška posteljica',
        extra_bed: 'Dodatna postelja',
        pet: 'Hišni ljubljenček',
        allergy: 'Alergija',
        products: 'Posebna čistila',
        extra_towels: 'Dodatne brisače',
        extra_pillows: 'Dodatni vzglavniki',
        clean_at: 'Čiščenje ob',
        do_not_enter_before: 'Ne vstopaj pred',
        language: 'Jezik gosta',
        late_checkout: 'Pozna odjava',
        early_checkin: 'Zgodnja prijava',
        preferred_room: 'Gostova želena soba',
    },
    // "Označi za čiščenje" — soba, o kateri koledar ne pove nič, gre na današnji krog
    // takoj (docs/HOUSEKEEPING.md §17).
    mark: {
        title: 'Označi za čiščenje',
        room: 'Soba',
        room_placeholder: 'Izberi sobo',
        room_named: 'Soba {room}',
        note_placeholder: 'Npr. gost je razlil vino, ogled sobe ob 11h …',
        submit: 'Označi za čiščenje',
        marked_message: 'Soba {room} je na današnjem krogu.',
        reason_guest_request: 'Gost prosi za čiščenje',
        reason_complaint: 'Pritožba na sobo',
        reason_soiled: 'Umazano po čiščenju',
        reason_after_use: 'Po ogledu ali delu v sobi',
        already_open_title: 'Ta soba je danes že na krogu',
        open_task: 'Odpri nalogo',
        nobody: 'nedodeljeno',
        due_by: 'do {hour}',
        refused_out_of_service: 'Soba je izven uporabe. Najprej jo vrni v uporabo, potem jo je mogoče uvrstiti na krog.',
        failed: 'Sobe ni bilo mogoče označiti za čiščenje.',
    },
    history: {
        title: 'Kaj se je danes dogajalo',
        hint: 'Vsak korak, po vrsti kot se je zgodil.',
        generated: 'Uvrščeno na list',
        assigned: 'Dodeljeno',
        reassigned: 'Predano naprej',
        started: 'Začeto',
        deferred: 'Preloženo',
        resumed: 'Ponovno začeto',
        finished: 'Končano',
        inspection_failed: 'Vrnjeno v čiščenje',
        rework_started: 'Popravlja se',
        finished_again: 'Znova končano',
        inspected: 'Potrjeno',
        skipped: 'Danes se ne čisti',
        marked_for_cleaning: 'Označeno za čiščenje',
        prioritised: 'Prednost postavljena',
        // Gostova prošnja in nadzorničin pritisk sta ista oznaka in različni vprašanji:
        // „kdo je 214 postavil naprej“ ima tu drug odgovor in drugega človeka.
        prioritised_by_guest: 'Gost je prosil za čiščenje — soba postavljena naprej',
        deprioritised: 'Prednost umaknjena',
        // An arrow and not a preposition. Slovenian would need the name declined here
        // ("na Marijo Sobarico"), and a name out of the database cannot be declined —
        // "na Marija Sobarica" is what that produces, and it reads as broken Slovenian
        // on every assignment in the house. The arrow says the same thing and asks
        // nothing of the name.
        to_person: '→ {name}',
        somebody: 'nekoga drugega',
        by_the_hotel: 'hotel',
    },
    linen: {
        title: 'Perilo',
        card_hint: 'Koliko čistega je ostalo v sobi in koliko umazanega je pobranega.',
        hint: 'Šteje se vsak kos — brisače, posteljnina, kopalni plašči, copati. Čisto gre z vozička v sobo, umazano iz sobe v koš.',
        open: 'Zapiši perilo',
        trolley: 'Tvoj voziček',
        basket: 'Koš za umazano',
        laundry: 'Pralnica',
        laundry_title: 'Pralnica',
        laundry_hint: 'Koliko umazanega gre v pralnico in koliko čistega na voziček.',
        left: 'Puščeno čistih',
        took: 'Pobrano umazanih',
        dropped: 'Oddano umazanih',
        taken: 'Prevzeto čistih',
        nothing: 'Vpiši vsaj eno količino.',
        needs_places: 'Izberi voziček, koš in pralnico.',
        saved: 'Perilo je zapisano.',
        save_failed: 'Nekaterih vpisov ni bilo mogoče zapisati — preveri stanje na Zalogah.',
        route_dirty: 'Umazano oddaš: {from} → {to}.',
        route_clean: 'Čisto vzameš: {from} → {to}.',
        same_place: 'Koš in pralnica sta isto mesto — umazano je že tam, vpiši samo prevzeto čisto.',
        rooms_missing: 'Recepcija naj med mesti zalog doda mesto vrste »V sobah«. Brez njega ni kam zapisati čistega perila, ki ostane v sobi.',
        no_linen: 'Hotel nima vpisanega perila. Recepcija ga doda med stvari zalog.',
    },
    stock: {
        title: 'Zaloge',
        hint: 'Kaj je na vozičku in v omari po nadstropjih.',
        short_title: 'Zmanjkuje',
        short_hint: 'Šteje se samo tisto, kar je danes mogoče dati na posteljo — brisače v pralnici niso brisače.',
        empty: 'Nič na zalogi.',
        every_place: 'Vsa mesta',
        move: 'Premakni',
        item: 'Kaj',
        what_happened: 'Kaj se je zgodilo',
        quantity: 'Koliko',
        // Vpisana količina gre po žici kot celo število v 10^decimalk enote artikla
        // (@/libs/quantity). Namig se pokaže samo tam, kjer artikel ni v kosih.
        quantity_invalid: 'Neveljavna količina.',
        quantity_step: 'Vpiši na {step} natančno ({unit}). Vejica ali pika.',
        from: 'Od kod',
        to: 'Kam',
        room: 'Soba',
        room_hint: 'Postavka gre na račun gosta v tej sobi.',
        note: 'Opomba',
        needs_item: 'Izberi stvar in količino.',
        save_failed: 'Premika ni bilo mogoče zapisati.',
        load_failed: 'Zalog ni bilo mogoče naložiti.',
        charged: 'Zapisano in zaračunano na sobo.',
        gone_sold: '→ Minibar — na račun sobe',
        gone_used: '→ Porabljeno',
        gone_damaged: '→ Poškodovano (odpis)',
        hint_soiled: 'Perilo gre med umazano — zabeleži se kot »v pralnico«.',
        hint_washed: 'Čisto perilo se vrača — zabeleži se kot »iz pralnice«.',
        hint_sold: 'Postavka gre na račun gosta v izbrani sobi.',
        hint_used: 'Stvar je porabljena in zapusti zalogo.',
        hint_damaged: 'Stvar je odpisana in zapusti zalogo.',
        reason_transfer: 'Prenos',
        reason_used: 'Porabljeno',
        reason_sold: 'Minibar — na račun sobe',
        reason_soiled: 'V pralnico',
        reason_washed: 'Iz pralnice',
        reason_damaged: 'Poškodovano',
        reason_delivery: 'Dobava',
        reason_count: 'Inventura',
    },
    // Ekipe: dve ali tri sobarice na isti sobi (docs/HOUSEKEEPING.md §15).
    team: {
        section:      'Ekipe',
        section_hint: 'Dve ali tri sobarice na isti sobi. Ekipa velja za en dan; jutri jo ponudimo nazaj z enim pritiskom.',
        pick_members: 'Izberi vsaj dve osebi',
        form:         'Sestavi ekipo',
        formed:       '{name} je sestavljena.',
        dissolve:     'Razpusti ekipo',
        open_rooms:   'še {count} sob',
        unnamed:      'Ekipa',
        with:         'z ekipo: {names}',
        factor_share: '{percent} % norme',

        // Zavihek Ekipe (v1.410.0). Sestavljanje se je preselilo sem iz razporeda:
        // ekipo se sprašuje vse jutro, razpored pa se pritisne enkrat.
        title:      'Ekipe',
        subtitle:   'Ekipe tega jutra',
        page_hint:  'Ekipa velja za en poslovni dan. Ime in članice se dajo urediti; jutri ju ponudimo nazaj z enim pritiskom.',
        suggestions: 'Včeraj sta delali skupaj',
        empty:      'Danes še ni nobene ekipe. Sestavi jo z gumbom zgoraj ali izberi včerajšnji par.',
        edit:       'Uredi ekipo',
        saved:      '{name} je shranjena.',

        name:         'Ime ekipe',
        name_hint:    'Kar piše na listu in kar se izgovori na hodniku. Največ 40 znakov, na isti dan enkratno.',
        members:      'Članice',
        members_hint: 'Vsaj dve. Kdor je v ekipi, tisti dan ne dobi samostojnih sob.',
        lead:         'Vodja',
        lead_hint:    'Neobvezno. Vodja je oseba, na katero se zapiše soba, da jo starejši zasloni še vedno pokažejo z imenom.',
        no_lead:      'Brez vodje',

        // Presek izmen: dve osemurni izmeni, ki se ne srečata, nista ekipa.
        no_common_shift:      'Izmeni se ne prekrivata — ekipa ne bi imela skupnega časa',
        no_common_shift_hint: 'Po urniku nista v hiši ob istem času. Ekipo je vseeno mogoče shraniti — urnik je načrt, hodnik je dejstvo — vendar razpored zanjo ne bo imel kdaj delati.',
        common_shift:         'Skupnega časa: {value}',
        common_shift_window:  'Skupaj {window} · {value}',
        shift_unknown:        'Urnik za to ekipo ni znan',

        rooms_today: '{done}/{total} sob danes',
        open_sheet:  'Pokaži na razporedu',

        // Razpored: ekipe se tu samo berejo.
        working_today: 'Ekipe, ki danes delajo. Vsaka je izvajalec razporeda — sestavljajo in razpuščajo se v zavihku Ekipe.',
        manage:        'Uredi ekipe',
        none_today:    'Danes ni nobene ekipe.',

        create_failed:   'Ekipe ni bilo mogoče sestaviti.',
        save_failed:     'Ekipe ni bilo mogoče shraniti.',
        name_taken:      'Ekipa s tem imenom danes že obstaja. Izberi drugo ime.',
        dissolve_failed: 'Ekipe ni bilo mogoče razpustiti. Če ima še odprte sobe, jih najprej prerazporedi.',
        dissolve_open_rooms: 'Ekipa ima še {count} odprtih sob. Najprej jih prerazporedi — sobe se ne vrnejo same vodji.',

        // Dva konca istega pravila: oseba je v ekipi ALI ima sobe sama, nikoli oboje.
        conflict_in_team: '{name} je danes že v ekipi {team}.',
        conflict_solo:    '{name} ima danes še sama sobe: {rooms}. Najprej jih prerazporedi.',
        refused:          'Ekipa ni bila sestavljena',

        // Izhod iz zavrnitve po odločitvi 4: delo, ki se še ni začelo, gre nazaj med
        // nedodeljeno, oseba pa se doda v ekipo. Soba, v kateri stoji, ostane njena.
        solo_work:        'ima samostojno delo ({rooms})',
        solo_in_progress: 'V sobi {rooms} je pravkar notri — ekipo bo mogoče shraniti, ko jo konča.',
        release_and_add:  'Razveljavi delo in dodaj v ekipo',
        release_confirm:  'Sobe {rooms} gredo nazaj med nedodeljene, {name} pa se doda v ekipo. Nadaljujem?',
        released:         'Sproščeno: {rooms}',
        release_kept:     '{name} je še vedno v sobi {rooms}. Ekipo je mogoče shraniti šele, ko jo konča.',
        release_failed:   'Dela ni bilo mogoče razveljaviti.',
    },
    plan: {
        title: 'Predlagaj razpored',
        hint: 'Sistem predlaga, ti odločiš. Sešteje norme, razdeli po nadstropjih in postavi naprej sobe, ki imajo uro.',
        people: 'Kdo dela',
        people_hint: 'Kdo je danes na razporedu — tega ne ve nihče razen tebe.',
        shift: 'Dolžina izmene (ur)',
        shift_hint: 'Koliko časa ima vsaka. Po tem se pozna, kaj v jutro ne gre.',
        propose: 'Predlagaj',
        summary: 'Dela za {work}, zmogljivost {capacity}.',
        nothing: 'nič',
        unnamed: 'brez imena',
        left_over_title: 'Brez izvajalca: {count}',
        apply: 'Uporabi razpored',
        applied: 'Dodeljenih sob: {count}.',
        // Ena vrstica namesto kupa opozoril: petnajst klicev, od tega deset zavrnjenih,
        // je bilo prej deset enakih obvestil čez uspeh. Razlogi so združeni pod povzetkom.
        applied_partial: 'Dodeljenih sob: {done} · ni bilo mogoče: {failed}',
        refused_group: '{rooms} — {reason}',
        no_executor: 'soba nima izvajalca',
        needs_people: 'Izberi vsaj eno osebo.',
        failed: 'Predloga ni bilo mogoče pripraviti.',
        floor_action: 'Razporedi nadstropje',
        // Ko na nadstropju ni več nedodeljenih sob, gumb ni več naslednji korak,
        // ampak odločitev — zato se umakne in preimenuje.
        floor_action_again: 'Prerazporedi',
        floor_hint: '{floor}: vse sobe se enakomerno razdelijo med izbrane. Brez omejitve izmene — nobena soba ne ostane zunaj.',
        floor_work: 'Sob na nadstropju: {rooms} · dela za {work}.',
        include_assigned: 'Prerazporedi tudi že dodeljene (nezačete)',
        include_assigned_hint: 'V delitev gredo tudi sobe, ki jih nekdo že ima, a jih še ni začel. Soba, ki se čisti zdaj, ostane pri njej.',
        moves: 'Premaknjenih sob: {moved} · ostane na mestu: {kept}.',
        kept: 'Ostane pri isti osebi',
        kept_count: 'ostane na mestu: {count}',
        kept_legend: 'Sobe s ključavnico ostanejo pri isti osebi — delo že poteka. Njihov čas je vštet v seštevek.',
        nothing_to_move: 'Nobene sobe ni treba premakniti.',

        // Ekipe, ki jih sestavi predlog sam (docs/HOUSEKEEPING.md §15, faza 4).
        form_teams: 'Sestavi ekipe za sobe, ki priporočajo dve ali tri',
        form_teams_hint: 'Za sobe, označene z večjo ekipo, predlog sam sestavi pare — najraje tiste, ki so delali skupaj včeraj. Kdor je v ekipi, ne dobi samostojnih sob. Ekipe nastanejo šele, ko pritisneš „Uporabi“.',
        proposed: 'predlog',
        formed_for: 'predlagana za {rooms} — priporočena velikost {size}',
        formed_yesterday: 'včeraj sta delali skupaj',
        drop_team: 'Brez te ekipe',
        shortfall_line: 'Za {rooms} je priporočena ekipa {size}, prostih pa je {available}. Zniža se priporočilo, pokliče koga ali izklopi sestavljanje ekip.',
    },
    forecast: {
        title: 'Jutri',
        hint: 'Kar po normah hotela nosi jutrišnji dan, skupaj s skupnimi prostori, ki so na vrsti.',
        work: 'Predvideno delo',
        rooms: 'Sobe',
        rooms_split: '{departures} odhodov · {stayovers} med bivanjem · {arrivals} prihodov',
        people: 'Potrebnih ljudi',
    },
    live: {
        window: 'okno {minutes} min',
        temperature: '{value}°',
        dnd: 'NE MOTI',
        mur: 'POSPRAVI SOBO',
        silent: 'ni podatka',
    },
    task: {
        retry_hour: 'Ob uri',
        retry_at_hour: 'Ura',
        kind_area_description:  'Skupni prostor po urniku objekta — ne soba gosta.',
        kind_area:              'Skupni prostor',
        status_deferred: 'Preloženo',
        status_rework: 'Za ponovno čiščenje',
        defer: 'Preloži',
        deferred_message: 'Soba je preložena na pozneje.',
        deferred_message_area: 'Prostor je preložen na pozneje.',
        deferred_no_hour: 'preloženo',
        retry_when: 'Kdaj poskusiti znova',
        retry_30: '30 min',
        retry_60: '1 ura',
        retry_120: '2 uri',
        retry_at: 'znova ob {value}',
        retry_overdue: 'zamuja od {value}',
        reason: 'Razlog',
        reason_note: 'Opomba',
        reason_note_placeholder: 'Na primer: gost je prosil, da pridemo po 15h.',
        reason_guest_present: 'Gost je v sobi',
        reason_other: 'Drugo',
        rework: 'Vrni v čiščenje',
        rework_message: 'Soba je vrnjena v čiščenje.',
        rework_message_area: 'Prostor je vrnjen v čiščenje.',
        rework_consequence: 'Soba se vrne med sobe za urediti in je ni mogoče prodati, dokler ni znova počiščena in sprejeta.',
        rework_consequence_area: 'Prostor se vrne med delo za urediti in velja za neurejenega, dokler ni znova počiščen in sprejet.',
        rework_reason: 'Kaj ni v redu',
        rework_note: 'Kaj je treba popraviti',
        rework_note_placeholder: 'Na primer: tuš ni obrisan, manjkata dve brisači.',
        rework_due_by: 'Popraviti do',
        rework_due_by_hint: 'Ura, do katere mora biti soba pripravljena. Prazno pomeni brez roka.',
        rework_due_by_hint_area: 'Ura, do katere mora biti prostor urejen. Prazno pomeni brez roka.',
        rework_bathroom: 'Kopalnica',
        rework_beds: 'Postelje',
        rework_supplies: 'Manjka potrošni material',
        rework_missed: 'Soba ni bila počiščena',
        rework_damage: 'Poškodba ali madež',
        status_pending:     'Čaka',
        // Odjava in sprostitev sobe sta dva dogodka (docs/HOUSEKEEPING.md §16).
        status_awaiting_release: 'Čaka sprostitev',
        awaiting_release_hint:   'Gost je odjavljen, sobe pa še ni sprostil - ni je še zapustil. Ko sporoči, da je soba prazna (recepcija, ključ, gostov zaslon), soba pride na vrsto.',
        awaiting_release_refused: 'Soba še ni sproščena — gost je odjavljen, sobe pa še ni zapustil. Ko jo sprosti, pride na vrsto.',
        status_in_progress: 'V delu',
        status_done:        'Opravljeno',
        status_inspected:   'Pregledano',
        status_skipped:     'Preskočeno',

        kind_departure: 'Odhod',
        kind_stayover:  'Ostaja',
        kind_arrival:   'Prihod',
        kind_dirty:             'Za urediti',
        kind_dirty_done:        'Urejeno',

        kind_departure_description: 'Gost je odšel. Sobo v celoti pripravi: preobleci posteljo, počisti kopalnico in dopolni potrošni material.',
        kind_stayover_description:  'Gost ostaja v sobi. Dnevno čiščenje okrog njegovih stvari — postelja, kopalnica, koši, brisače.',
        kind_arrival_description:   'Soba je prazna in danes pride gost. Pripravi jo in preglej, preden vstopi.',
        kind_dirty_description: 'Soba čaka na ureditev, čeprav ta dan nihče ne prihaja in nihče ni prespal. Pripravi jo do konca.',

        consequence_done:           'Soba je počiščena. Ko je sprejeta, je pripravljena za naslednjega gosta.',
        consequence_inspected:      'Soba je sprejeta in pripravljena za naslednjega gosta.',
        consequence_stayover_done:  'Dnevno čiščenje je opravljeno, soba pa ostane zasedena — ni pripravljena za novega gosta.',
        guest_still_in_room:        'Gost je še v sobi',

        room_unknown: 'Neznana soba',
        floor:         'Nadstropje',
        business_date: 'Poslovni dan',
        started_at:    'Začeto',
        finished_at:   'Končano',
        inspected_at:  'Pregledano',
        notes:         'Opomba',

        // Norma je pripomoček za načrtovanje, ne ocena dela. Nikjer ni napisana kot
        // graja: soba čez normo je soba, ki je norma ni opisala.
        norm:       'Norma',
        norm_short: 'norma {value}',
        // Norma ekipe je delež sobne norme. Brez druge polovice stavka „33 min“ pod
        // apartmajem z devetdesetminutno normo izgleda kot napaka.
        norm_team:  '(ekipa {size} · {solo} za eno)',
        remaining:              'še {value}',
        over_by:                'čez {value}',
        over_norm:  'Čez normo za {value}',
        elapsed:    'Traja',
        duration:   'Trajanje',

        unassigned:        'Nedodeljeno',
        worked_by:              'Opravljeno: {name}',
        awaiting_inspection:    'Čaka pregled',

        stay_changed: 'Rezervacija se je spremenila, potem ko se je soba že začela',
        stay_gone: 'Rezervacija, zaradi katere je bila ta soba na listu, je odpovedana ali prestavljena. Delo je še vedno tvoje — dokončaj ali preskoči, odloči nadzor.',
        stay_now_kind: 'Koledar zdaj pravi, da ta soba potrebuje: {kind}. Tvoja naloga ni bila spremenjena; javi nadzoru.',
        stay_now_due: 'Gost je zdaj pričakovan ob {time}, ne ob uri na tej nalogi.',
        stay_no_longer_due: 'Ura, zaradi katere je bila ta soba nujna, ne velja več.',
        due_by:                 'do {time}',

        priority:               'Prednost',

        // Kaj piše na gumbu, in obe strani istega gumba: soba, ki je že prva, je soba,
        // ki jo nekdo umakne. „Naredi prvo“ in ne „Prednost“ — gumb pove dejanje, značka
        // pa stanje, in isti besedi za oboje bi bralec moral ugibati, katero od tega je.
        priority_set:   'Naredi prvo',
        priority_clear: 'Umakni prednost',
        priority_hint:  'Soba gre na vrh današnjega kroga.',
        priority_set_message:     'Soba je na vrhu današnjega kroga',
        priority_cleared_message: 'Soba je spet po vrsti',

        assigned_to:       'Dodeljeno',
        assigned_to_you:   'Tebi',
        assigned_to_other: 'Drugi osebi',

        assign:           'Dodeli',
        assign_to:        'Dodeli osebi',
        not_on_rota: 'danes ni na urniku',

        // Kdo je danes že v ekipi — pripis ob imenu v vseh treh izbirnikih, takoj za
        // urnikom: „Marija Sobarica · 06:00–14:00 · v ekipi Ekipa A“. Storitev tako
        // osebo povsod zavrne (oseba je v ekipi ALI dela sama), zato pripis ni
        // opozorilo, ampak razlog — ime je zatemnjeno in se ne da izbrati.
        in_team:         'v ekipi {name}',
        already_in_team: 'že v ekipi {name}',

        // Ure izmene pod imenom izvajalca. Za ekipo je to presek izmen njenih članic —
        // okno, v katerem je ekipa sploh ekipa.
        no_shift:    'brez turnusa',
        assigned_message: 'Soba je dodeljena',
        assigned_message_area: 'Prostor je dodeljen',

        actions: 'Dejanja',

        start:            'Začni',

        // „Prevzemi“ in ne „Začni“ povsod, kjer soba še ni njena: pritisk sobo zapiše
        // na osebo, ki ga naredi (Logic — kdor sobo vzame, si jo dodeli), in to mora
        // beseda povedati pred pritiskom in ne po njem. Doslej je vrstica na listu
        // rekla „Prevzemi“ tudi pri njenih lastnih sobah, stran naloge pa „Začni“ tudi
        // pri tujih — en gumb, dve besedi, vsaka napačna v polovici primerov.
        take_over:        'Prevzemi',

        // Soba, v kateri je nekdo drug. Namesto gumba, ne poleg njega.
        in_progress_by:   'v delu · {name}',
        started_message:  'Soba je začeta',
        started_message_area: 'Prostor je začet',

        // Prevzem tuje sobe. Pove tisto, česar gumb ne pove: soba se zapiše na osebo,
        // ki jo prevzame, in ta s tem izgubi pravico, da bi jo sama sprejela.
        take_over_title:   'Soba je dodeljena drugi osebi',
        take_over_title_area:   'Prostor je dodeljen drugi osebi',
        take_over_message: 'Ta soba je na krogu osebe {name}. Če jo začneš, bo delo zapisano nate — sobe, ki jo počistiš, potem ne moreš sprejeti. Sprejeti jo mora druga oseba.',
        take_over_message_area: 'Ta prostor je na krogu osebe {name}. Če ga začneš, bo delo zapisano nate — prostora, ki ga počistiš, potem ne moreš sprejeti. Sprejeti ga mora druga oseba.',
        take_over_action:  'Prevzemi in začni',

        // Kratko vprašanje za vse ostale. Zgornje je nadzorničino in pove več — s
        // prevzemom izgubi pravico, da bi sobo sama sprejela — to pa je za sobarico, ki
        // je doslej ni nič vprašalo: soba druge ekipe je zamenjala lastnika z enim
        // pritiskom. Ime je ime izvajalca, torej „Ekipi B“ pri ekipni sobi.
        take_over_short_message:      'Soba je dodeljena: {name} — prevzameš?',
        take_over_short_message_area: 'Prostor je dodeljen: {name} — prevzameš?',

        finish:           'Končaj',
        finished_message: 'Soba je končana',
        finished_message_area: 'Prostor je končan',

        finish_without_start:         'Delo je že opravljeno',
        finish_without_start_confirm: 'Ta soba še ni bila začeta. Zabeležili jo bomo kot začeto zdaj in takoj zaključeno, zato čas čiščenja ne bo pravilen. Če delo šele začenjaš, uporabi Začni.',
        finish_without_start_confirm_area: 'Ta prostor še ni bil začet. Zabeležili ga bomo kot začetega zdaj in takoj zaključenega, zato čas čiščenja ne bo pravilen. Če delo šele začenjaš, uporabi Začni.',

        skip:            'Preskoči',
        skip_confirm:    'Soba ne bo počiščena. Zapiši razlog, da nadzor ve, zakaj.',
        skip_confirm_area:    'Prostor ne bo počiščen. Zapiši razlog, da nadzor ve, zakaj.',
        skipped_message: 'Soba je preskočena',
        skipped_message_area: 'Prostor je preskočen',

        inspect:           'Potrdi sobo',
        inspect_area:           'Potrdi prostor',
        inspect_confirm:   'S tem potrdiš, da je soba pregledana in pripravljena za gosta. Tega ni mogoče preklicati.',
        inspect_confirm_area:   'S tem potrdiš, da je prostor pregledan in urejen. Tega ni mogoče preklicati.',
        inspected_message: 'Soba je potrjena',
        inspected_message_area: 'Prostor je potrjen',

        note_title: 'Opomba',
        note_hint:  'Kar zapišeš, gre skupaj s Končaj ali Preskoči in to prebere nadzor.',

        reason_do_not_disturb: 'Ne moti',
        reason_guest_declined: 'Gost je odklonil čiščenje',
        reason_no_access:      'Do sobe ni bilo dostopa',

        not_found:  'Naloge ni mogoče najti.',
        no_actions: 'Za to sobo nimaš razpoložljivih dejanj.',
        no_actions_area: 'Za ta prostor nimaš razpoložljivih dejanj.',

        closed_done:      'Soba je počiščena in čaka na pregled.',
        closed_done_area:      'Prostor je počiščen in čaka na pregled.',
        closed_inspected: 'Soba je sprejeta in pripravljena. Delo za danes je zaključeno.',
        closed_inspected_area: 'Prostor je sprejet in urejen. Delo za danes je zaključeno.',
        closed_skipped:   'Soba je bila preskočena. Za danes tu ni več dela.',
        closed_skipped_area:   'Prostor je bil preskočen. Za danes tu ni več dela.',

        load_failed:   'Nalog ni bilo mogoče naložiti.',
        action_failed: 'Dejanja ni bilo mogoče izvesti.',
    },
    statistics: {
        rework: 'Ponovno čiščenje',
        deferred: 'Preloženo',
        of_which_dnd: 'od tega {count} „ne moti"',
        faults: 'Najdene okvare',
        late: 'Zamude glede na uro',
        late_of: '{late} od {total}',
        title:    'Statistika',
        subtitle: 'Opravljeno delo po osebah, ekipah, vrstah dela in dnevih',

        period_today: 'Danes',
        period_week:  '7 dni',
        period_month: 'Ta mesec',

        range: 'od {from} do {to}',

        tasks:     'Sob',
        done:      'Počiščeno',
        inspected: 'Pregledano',
        skipped:   'Preskočeno',

        average:    'Povprečje na sobo',
        norm:       'Norma na sobo',
        norm_short: 'norma {value}',
        per_room:   'na sobo',
        worked:     'Skupaj dela',
        // Imenovalec povprečja se pove naglas: povprečje štirih sob in povprečje
        // štiridesetih nista isto dejstvo in ne smeta biti videti enako.
        timed:      'Merjenih sob',

        by_person:      'Po osebah',
        by_person_hint: 'Delo se šteje tistemu, ki ga je opravil — kdor je pritisnil Začni. Ekipna soba se v celoti šteje vsaki članici, ker sta bili v njej obe. Sobe, ki jih ni začel nihče, so v vrstici Nedodeljeno.',
        by_team:        'Po ekipah',
        by_team_hint:   'Kar je opravila ekipa, in ne seštevek dveh oseb: obe sta bili v vseh sobah. Norma je pomnožena s faktorjem ekipe.',
        by_kind:        'Po vrsti dela',
        by_day:         'Po dnevih',

        // Ekipni del je PODMNOŽICA sob nad njim in nikoli prištevek: apartma, ki sta ga
        // počistili dve, je ena soba, ki jo je hiša počistila.
        team_work:        'V ekipi',
        in_team:          'v ekipi {count}',
        in_team_minutes:  'v ekipi {value}',
        efficiency:       'Glede na normo',
        efficiency_short: '{percent} %',

        unassigned:     'Nedodeljeno',
        person_unknown: 'Neznana oseba',
        team_unknown:   'Neznana ekipa',

        empty:       'V tem obdobju ni zabeleženega dela.',
        load_failed: 'Statistike ni bilo mogoče naložiti.',
    },
    service: {
        title: 'Moje storitve',
        description: 'Termini, ki jih izvajaš danes. Zaporedje je po uri.',
        empty: 'Za ta dan ni terminov.',
        today: 'Danes',
        tomorrow: 'Jutri',
        view_day: 'Dan',
        view_week: 'Teden',
        view_month: 'Mesec',
        includes_today: 'Vključuje danes',
        period_count: 'Terminov: {count}',
        period_hours: 'Skupaj {hours} h',
        previous_day: 'Prejšnji dan',
        next_day: 'Naslednji dan',
        all_day: 'Ves dan',
        days_count: '{count} dni',
        hand_over: 'Izdaj',
        handed_over: 'Izdano',
        handed_over_done: 'Izdano gostu.',
        take_back: 'Vrnjeno',
        returned: 'Vrnjeno',
        returned_done: 'Zabeleženo kot vrnjeno.',
        to_hand_over: 'Za izdajo',
        hire_hours: 'Izdaja {pickup} · vračilo {back}',
        walk_in: 'Brez gosta',
        status_booked: 'Naročeno',
        status_in_progress: 'V teku',
        status_completed: 'Končano',
        start: 'Začni',
        book: 'Rezerviraj',
        booked: 'Termin je rezerviran',
        book_title: 'Nov termin',
        book_service: 'Storitev',
        book_guest: 'Gost',
        book_guest_hint: 'Ime, kot ga pove gost. Lahko pustiš prazno.',
        book_time: 'Prosti termini',
        book_no_slots: 'Za ta dan ni prostih terminov.',
        book_failed: 'Termina ni bilo mogoče rezervirati.',
        started: 'Storitev je v teku',
        finish: 'Zaključi',
        finished: 'Storitev je zaključena',
        finish_title: 'Zaključi storitev',
        finish_question: 'Kako je gost plačal?',
        finish_free_hint: 'Ta storitev nima cene — zaključi se brez obračuna.',
        settle_folio: 'Na sobo',
        settle_folio_hint: 'Gre na kartico gosta, plača ob odjavi.',
        settle_folio_no_stay: 'Ni mogoče — termin ni vezan na bivanje.',
        settle_paid: 'Takojšnje plačilo',
        settle_paid_hint: 'Na kartico ne gre nič.',
    },
    license: {
        title:   'Ta storitev ni vključena',
        lead:    'Housekeeping in vzdrževanje nista del naročnine te hiše, zato ta portal ne more prikazati ničesar.',
        switch_account: 'Prijavi se z drugim računom',
        contact: 'Za vklop se obrni na sistemskega skrbnika. Podatki hiše ostanejo nedotaknjeni.',
    },
    errors: {
        operation_in_progress: 'Ta vnos se že knjiži. Ne tapni znova — preveri med gibanji, ali je zapisan.',
        operation_mismatch: 'Ta zaslon je zastarel: isti vnos je bil začet z drugačno vsebino. Osveži in vnesi znova.',
        generic_error: 'Prišlo je do napake',
        invalid_data:  'Neveljavni podatki',
        not_found:     'Ni najdeno',
        unauthorized:  'Za to dejanje nimaš pravice',
        staff_not_employed: 'Za te dneve nimaš vpisanega obdobja zaposlitve. Povej vodji — kadrovski karton uredi ona.',
        staff_time_sequence: 'Vrstni red žigov ni mogoč (npr. prihod na že odprt dan).',
        staff_time_out_of_range: 'Čas žiga je izven dovoljenega okna.',
        staff_break_recording_off: 'Hiša ne beleži odmorov.',
        staff_self_decision: 'Svoje zahteve ne moreš potrditi sam.',
        staff_pin_ambiguous: 'Ta PIN uporablja več zaposlenih — vodja naj enemu izda novega.',
        staff_pin_throttled: 'Preveč poskusov s PIN. Počakaj in poskusi znova.',
        group_hold_picked_up: 'Držana soba je že prevzeta.',
        session_expired: 'Seja je potekla. Prijavi se znova — narejeno ni bilo nič.',
        state_moved_on: 'Sobo je medtem spremenil nekdo drug. Zaslon je osvežen — poglej, kje je, in poskusi znova.',
        room_in_progress_by_other: 'Soba je v delu pri drugem.',
        conflict:      'Zapis že obstaja',
        on_add:        'Napaka pri dodajanju',
        on_load:       'Napaka pri branju',
        on_edit:       'Napaka pri shranjevanju',
    },
    success: {
        add:  'Uspešno dodano',
        edit: 'Uspešno shranjeno',
    },
    validation: {
        required: 'To polje je obvezno',
        email:    'Neveljaven e-naslov',
    },
    // Milo, isti kot na recepciji (docs/AI.md § „Milo v portalu sobaric"). Besedila so
    // ista kot v pms-web, razen treh: pozdrav je imenoval recepcijo, uvod je našteval
    // rezervacije in analitiko, primeri vprašanj pa so bili recepcijski — nadzornica bi
    // na „Kakšen je prihodek ta mesec?" dobila zavrnitev pravice, in prvo, kar bi Milo
    // rekel, bi bil „ne smeš".
    assistant: {
        history:           'Zgodovina pogovorov',
        history_search:    'Išči po naslovih …',
        new_conversation:  'Nov pogovor',
        read_only:         'Pogovor druge osebe — samo za branje.',
        confirm:   'Potrdi',
        decline:   'Zavrni',
        executed:  'Izvedeno',
        op_failed: 'Ni uspelo',
        declined:  'Zavrnjeno',
        already_decided: 'Že odločeno — poskus je prišel prepozno, predlog je bil medtem že obravnavan.',
        title:        'Milo',
        greeting:     'Sem Milo, pomočnik na tvojem nadstropju.',
        intro:        'Vprašaj karkoli o hiši — sobe, jutranji razpored, sobarice, vzdrževanje, zaloge. Milo bere žive podatke; kar bi spremenil, najprej predlaga in ti potrdiš.',
        placeholder:  'Vprašaj …',
        thinking:     'Milo preverja podatke …',
        still_working: 'Milo dela … (lahko traja do minute)',
        failed:       'Milo ni mogel odgovoriti. Poskusi znova.',
        // Neuspel obrat se odslej izriše v niti in ne samo kot obvestilo (§20).
        // Svoj stavek za primer, ko storitve ni — objava, ponovni zagon, prehod, ki
        // odgovori namesto nje —, ker takrat vprašanja ni treba preubesediti, ampak
        // počakati; vsak drug razlog pove strežnik sam (parseError).
        failed_unreachable: 'Milo ni mogel odgovoriti: strežnik trenutno ni dosegljiv — poskusi čez pol minute.',
        failed_timeout:     'Milo je za to vprašanje potreboval predolgo. Vprašaj ožje ali vprašanje razdeli na dva dela.',
        failed_lost:        'Milo je bil med odgovarjanjem prekinjen (posodobitev storitve). Pošlji vprašanje znova.',
        retry:        'Pošlji znova',
        disclaimer:   'Milo bere žive podatke; kar bi spremenil, najprej predlaga in ti potrdiš. Številke preveri na ustreznem zaslonu, preden ukrepaš.',
        example_arrivals:     'Katere sobe še niso pospravljene?',
        example_availability: 'Kdo dela danes?',
        example_revenue:      'Kaj je odprtega na vzdrževanju?',
        waits_for_step:       'čaka na korak {step}',
        step_prepared_below:  'Milo ga pripravlja spodaj',
        continued:            'Korak izveden — Milo nadaljuje z naslednjim.',
        // Krogla v vrstici, predal in zavedanje strani.
        shortcut:       'Alt+J',
        orb_attention:  'Nekaj čaka nate',
        // Nadomestno besedilo posterja, dokler se 3D glava nalaga (MiloHead.vue).
        head_loading:   'Milo se nalaga …',
        on_page:        'Na strani: {subject}',
        on_page_hint:   'Milo ve, kaj imaš odprto. Klikni, če vprašanje ni o tem.',
        on_page_drop:   'Odstrani „{subject}“ iz vprašanja',
        // Povezave v odgovoru in v vrstici o izvedbi (libs/linkify.ts).
        copy_link:        'Kopiraj povezavo',
        link_copied:      'Povezava je kopirana.',
        link_copy_failed: 'Kopiranje ni uspelo — povezavo označi in kopiraj ročno.',
    },
    // Kaj je izvedba naredila. Strežnik pošlje kodo in število (ChatOperationOutcome),
    // stavek sestavi zaslon — ker je stavek strežnika angleški revizijski zapis in ne
    // besedilo za osebje. Kode brez štetja imajo samo obliko `other`.
    //
    // Cel blok je prepisan iz pms-web in ne okrnjen: koda pride s strežnika, ki ne ve,
    // kateri portal bere odgovor, in manjkajoča koda bi pomenila, da zaslon pokaže
    // angleški revizijski stavek namesto slovenskega.
    assistant_result: {
        nights_priced: {
            one:   'posodobljena cena za 1 noč',
            other: 'posodobljene cene za {count} noči',
        },
        rooms_closed: {
            one:   'zaprta 1 soba',
            two:   'zaprti {count} sobi',
            few:   'zaprte {count} sobe',
            other: 'zaprtih {count} sob',
        },
        rooms_reopened: {
            one:   'v prodajo vrnjena 1 soba',
            two:   'v prodajo vrnjeni {count} sobi',
            few:   'v prodajo vrnjene {count} sobe',
            other: 'v prodajo vrnjenih {count} sob',
        },
        guests_retagged: {
            one:   'posodobljene oznake pri 1 gostu',
            other: 'posodobljene oznake pri {count} gostih',
        },
        tasks_assigned: {
            one:   'razporejena 1 naloga',
            two:   'razporejeni {count} nalogi',
            few:   'razporejene {count} naloge',
            other: 'razporejenih {count} nalog',
        },
        round_assigned: {
            one:   'razporejena 1 soba',
            two:   'razporejeni {count} sobi',
            few:   'razporejene {count} sobe',
            other: 'razporejenih {count} sob',
        },
        stays_moved: {
            one:   'premaknjeno 1 bivanje',
            two:   'premaknjeni {count} bivanji',
            few:   'premaknjena {count} bivanja',
            other: 'premaknjenih {count} bivanj',
        },
        group_hold_moved: {
            other: 'premaknjena držana soba — {detail}',
        },
        group_hold_restructured: {
            other: 'premaknjena držana soba in prestrukturiran blok skupine — {detail}',
        },
        group_hold_released: {
            other: 'sproščena držana soba, dogovorjeno število ostaja — {detail}',
        },
        group_room_picked_up: {
            other: 'prevzeta soba iz skupine — {detail}',
        },
        group_shifted: {
            one:   'zamaknjena skupina, premaknjena 1 soba — {detail}',
            two:   'zamaknjena skupina, premaknjeni {count} sobi — {detail}',
            few:   'zamaknjena skupina, premaknjene {count} sobe — {detail}',
            other: 'zamaknjena skupina, premaknjenih {count} sob — {detail}',
        },
        group_dates_changed: {
            one:   'spremenjen termin skupine, spremenjena 1 soba — {detail}',
            two:   'spremenjen termin skupine, spremenjeni {count} sobi — {detail}',
            few:   'spremenjen termin skupine, spremenjene {count} sobe — {detail}',
            other: 'spremenjen termin skupine, spremenjenih {count} sob — {detail}',
        },
        group_status_changed: {
            other: 'spremenjeno stanje skupine — {detail}',
        },
        mappings_saved: {
            one:   'shranjena 1 preslikava',
            two:   'shranjeni {count} preslikavi',
            few:   'shranjene {count} preslikave',
            other: 'shranjenih {count} preslikav',
        },
        program_proposed: {
            one:   'predlagana 1 točka programa za {detail}',
            two:   'predlagani {count} točki programa za {detail}',
            few:   'predlagane {count} točke programa za {detail}',
            other: 'predlaganih {count} točk programa za {detail}',
        },
        display_config_saved: {
            other: 'shranjena nastavitev sobnih zaslonov (revizija {detail})',
        },
        channel_linked: {
            other: 'rezervacija kanala povezana z obstoječo — {detail}',
        },
        channel_placed: {
            other: 'ustvarjena rezervacija {detail}',
        },
        channel_replayed: {
            other: 'rezervacija {detail} je nastala že ob prejšnji potrditvi; nova ni bila ustvarjena',
        },
        full_sync_accepted: {
            other: 'polna sinhronizacija ({detail}) je sprejeta in teče v ozadju',
        },
        comfort_confirmed: {
            other: 'oprema je potrdila — soba {detail}',
        },
        comfort_sent: {
            other: 'ukaz poslan sobi {detail}; oprema ga še ni potrdila',
        },
        comfort_unconfirmed: {
            other: 'ukaz je odšel in NI potrjen — {detail}',
        },
        issue_reported: {
            other: 'ustvarjen nalog za vzdrževanje — {detail}',
        },
        issue_appended: {
            other: 'dopolnjen obstoječi nalog »{detail}«; nov ni bil ustvarjen',
        },
        issue_already_added: {
            other: 'nalog »{detail}« je to dopolnilo že imel; dopisano ni bilo nič',
        },
        message_sent: {
            other: 'poslano na {detail}',
        },
        checked_in: {
            one:   'prijavljena 1 soba',
            two:   'prijavljeni {count} sobi',
            few:   'prijavljene {count} sobe',
            other: 'prijavljenih {count} sob',
        },
        checked_out: {
            one:   'zaključen obračun in odjavljena 1 soba',
            two:   'zaključen obračun in odjavljeni {count} sobi',
            few:   'zaključen obračun in odjavljene {count} sobe',
            other: 'zaključen obračun in odjavljenih {count} sob',
        },
        room_prioritised: {
            other: 'soba {detail} je na vrhu današnjega kroga',
        },
        room_released: {
            other: 'soba {detail} je sproščena za čiščenje',
        },
        reservation_created: {
            other: 'ustvarjena rezervacija — {detail}',
        },
        offer_created: {
            one:   'ustvarjena ponudba za 1 sobo — {detail}',
            two:   'ustvarjena ponudba za {count} sobi — {detail}',
            few:   'ustvarjena ponudba za {count} sobe — {detail}',
            other: 'ustvarjena ponudba za {count} sob — {detail}',
        },
        offer_sent: {
            other: 'ponudba poslana — {detail}',
        },
        // Dve kodi in ne ena: „shranjeno“ nad zapisom, ki je že obstajal, skrije edino
        // stvar, ki je vredna branja — ali ima hiša odslej DRUGI račun za isto pravno
        // osebo ali ne. Popravek šteje polja in ne stvari, zato ima samo obliko other.
        company_created: {
            other: 'odprt poslovni partner — {detail}',
        },
        company_updated: {
            other: 'popravljen poslovni partner — {detail}',
        },
        // Šteje POLJA in ne stvari — „spremenjeni 2 polji“ — ker je popravek kartice
        // gosta lahko en telefon ali pol kartoteke, in tisti, ki bere nit teden
        // pozneje, hoče vedeti, koliko se je premaknilo. Ime gosta je v {detail}.
        guest_updated: {
            one:   'popravljena kartica gosta — spremenjeno 1 polje · {detail}',
            two:   'popravljena kartica gosta — spremenjeni {count} polji · {detail}',
            few:   'popravljena kartica gosta — spremenjena {count} polja · {detail}',
            other: 'popravljena kartica gosta — spremenjenih {count} polj · {detail}',
        },
        // Popust ima DVE kodi in to je vsa vsebina odgovora: znotraj meje je denar že
        // odbit, nad njo ni odbito NIČ in zahtevek čaka. Ena poved za oboje bi bila
        // cena, ki jo recepcija pove gostu, hiša pa se z njo še ni strinjala.
        discount_applied: {
            other: 'popust odbit — {detail}',
        },
        discount_pending: {
            other: 'zahtevek za popust čaka odobritev; z računa ni odbito nič — {detail}',
        },
        line_removed: {
            other: 'postavka umaknjena (storno) — {detail}',
        },
        line_moved: {
            other: 'postavka prenesena v celoti — {detail}',
        },
        line_split: {
            other: 'postavka razdeljena — {detail}',
        },
        overpayment_refunded: {
            other: 'preplačilo vrnjeno — {detail}',
        },
        payment_transferred: {
            other: 'plačilo preneseno med karticama; hiša ni izplačala ničesar — {detail}',
        },
        absence_approved: {
            one:   'odsotnost odobrena — v evidenco zapisan 1 dan · {detail}',
            two:   'odsotnost odobrena — v evidenco zapisana {count} dneva · {detail}',
            few:   'odsotnost odobrena — v evidenco zapisani {count} dnevi · {detail}',
            other: 'odsotnost odobrena — v evidenco zapisanih {count} dni · {detail}',
        },
        absence_rejected: {
            other: 'odsotnost zavrnjena; v evidenco ni bil zapisan noben dan — {detail}',
        },
        correction_approved: {
            other: 'popravek evidence odobren — {detail}; prvotni vpis je označen kot popravljen',
        },
        correction_rejected: {
            other: 'popravek evidence zavrnjen; evidenca ostaja nespremenjena — {detail}',
        },
        notice_queued: {
            other: 'sporočilo uvrščeno v vrsto — {detail}',
        },
        shift_changed: {
            other: 'turnus premaknjen — {detail}',
        },
    },
}
